// Shell for the CARS TEAM's own login — the same idea as OpsLayout, kept
// deliberately plain.
//
// The car team has one job on this app: work the lot. So there is one screen
// and no navigation to get lost in — a header saying who is signed in and the
// way out, and the lot underneath.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiKey, FiLogOut } from 'react-icons/fi';
import { capcrmlogo } from '../../assets';
import { carsTeamAuth } from '../../api/carsApi';
import StorageUtil from '../../utils/storage';

const CarsWorkLayout = ({ children }) => {
  const navigate = useNavigate();
  const staff = StorageUtil.getCarsStaff();

  const handleLogout = async () => {
    await carsTeamAuth.logout();
    navigate('/login?tab=cars');
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white shadow-sm">
        <div className="mx-auto flex h-14 max-w-5xl items-center gap-3 px-4">
          <div className="flex shrink-0 items-center gap-2.5">
            <img src={capcrmlogo} alt="CAP" className="h-8 w-8 shrink-0 object-contain" />
            <span className="leading-tight">
              <span className="flex items-center gap-1.5 text-sm font-bold text-slate-900">
                <FiKey className="h-3.5 w-3.5 text-violet-600" /> Cars
              </span>
              <span className="block text-[11px] text-slate-400">
                {staff?.name ? `Signed in as ${staff.name}` : 'The lot'}
              </span>
            </span>
          </div>

          <button
            onClick={handleLogout}
            title="Log out"
            className="ml-auto flex h-10 items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 text-sm font-semibold text-slate-500 transition-all hover:border-rose-200 hover:bg-rose-50 hover:text-rose-600"
          >
            <FiLogOut className="h-4 w-4" />
            <span className="hidden md:inline">Logout</span>
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-6">{children}</main>
    </div>
  );
};

export default CarsWorkLayout;
